/* eslint-disable */
import {
  BootstrapVue,
  BIcon,
  BIconstack,
  BIconArchive,
  BIconArrow90degLeft,
  BIconBoxArrowUpRight,
  BIconCalendar,
  BIconCheck,
  BIconCheckCircleFill,
  BIconDot,
  BIconDownload,
  BIconExclamationCircle,
  BIconExclamationTriangleFill,
  BIconEye,
  BIconEyeSlash,
  BIconFiles,
  BIconGear,
  BIconGearFill,
  BIconHeadphones,
  BIconHouseDoorFill,
  BIconInfoCircle,
  BIconLightningFill,
  BIconLink45deg,
  BIconLockFill,
  BIconPaperclip,
  BIconPencil,
  BIconPencilSquare,
  BIconPersonBadgeFill,
  BIconPersonFill,
  BIconSearch,
  BIconShieldLockFill,
  BIconSortDown,
  BIconSortUpAlt,
  BIconStar,
  BIconTrash,
  BIconChevronDoubleLeft,
  BIconChevronDoubleRight,
  BIconChevronBarUp,
  BIconChevronBarDown,
  BIconInfoCircleFill,
  BIconGripVertical,
  BIconCaretDownFill,
  BIconPlusCircleFill,
  BIconX,
} from 'bootstrap-vue';

export default function install(Vue, options = {}) {
  Vue.use(BootstrapVue);
  // Vue.use(BootstrapVueIcons);
  Vue.component('BIcon', BIcon);
  Vue.component('BIconstack', BIconstack);
  Vue.component('BIconArchive', BIconArchive);
  Vue.component('BIconArrow90degLeft', BIconArrow90degLeft);
  Vue.component('BIconBoxArrowUpRight', BIconBoxArrowUpRight);
  Vue.component('BIconCalendar', BIconCalendar);
  Vue.component('BIconCheck', BIconCheck);
  Vue.component('BIconCheckCircleFill', BIconCheckCircleFill);
  Vue.component('BIconDot', BIconDot);
  Vue.component('BIconDownload', BIconDownload);
  Vue.component('BIconExclamationCircle', BIconExclamationCircle);
  Vue.component('BIconExclamationTriangleFill', BIconExclamationTriangleFill);
  Vue.component('BIconEye', BIconEye);
  Vue.component('BIconEyeSlash', BIconEyeSlash);
  Vue.component('BIconFiles', BIconFiles);
  Vue.component('BIconGear', BIconGear);
  Vue.component('BIconGearFill', BIconGearFill);
  Vue.component('BIconHeadphones', BIconHeadphones);
  Vue.component('BIconHouseDoorFill', BIconHouseDoorFill);
  Vue.component('BIconInfoCircle', BIconInfoCircle);
  Vue.component('BIconLightningFill', BIconLightningFill);
  Vue.component('BIconLink45deg', BIconLink45deg);
  Vue.component('BIconLockFill', BIconLockFill);
  Vue.component('BIconPaperclip', BIconPaperclip);
  Vue.component('BIconPencil', BIconPencil);
  Vue.component('BIconPencilSquare', BIconPencilSquare);
  Vue.component('BIconPersonBadgeFill', BIconPersonBadgeFill);
  Vue.component('BIconPersonFill', BIconPersonFill);
  Vue.component('BIconSearch', BIconSearch);
  Vue.component('BIconShieldLockFill', BIconShieldLockFill);
  Vue.component('BIconSortDown', BIconSortDown);
  Vue.component('BIconSortUpAlt', BIconSortUpAlt);
  Vue.component('BIconStar', BIconStar);
  Vue.component('BIconTrash', BIconTrash);
  Vue.component('BIconChevronDoubleLeft', BIconChevronDoubleLeft);
  Vue.component('BIconChevronDoubleRight', BIconChevronDoubleRight);
  Vue.component('BIconChevronBarUp', BIconChevronBarUp);
  Vue.component('BIconChevronBarDown', BIconChevronBarDown);
  Vue.component('BIconInfoCircleFill', BIconInfoCircleFill);
  Vue.component('BIconGripVertical', BIconGripVertical);
  Vue.component('BIconCaretDownFill', BIconCaretDownFill);
  Vue.component('BIconPlusCircleFill', BIconPlusCircleFill);
  Vue.component('BIconX', BIconX);
}
